import type { ComponentType } from "react";

interface IconProps {
  className?: string;
}

const base = {
  viewBox: "0 0 24 24",
  fill: "none" as const,
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export const IconDrone: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <path d="M17.8 19.2L16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
  </svg>
);

export const IconClock: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

export const IconCompass: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <circle cx="12" cy="12" r="10" />
    <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
  </svg>
);

export const IconFlag: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
    <line x1="4" y1="22" x2="4" y2="15" />
  </svg>
);

export const IconAltitude: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <path d="M12 3l7 7" />
    <path d="M12 3L5 10" />
    <path d="M12 3v18" />
    <path d="M7 17h10" />
  </svg>
);

export const IconChart: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <line x1="3" y1="20" x2="21" y2="20" />
    <rect x="5" y="11" width="3" height="8" />
    <rect x="10.5" y="7" width="3" height="12" />
    <rect x="16" y="14" width="3" height="5" />
  </svg>
);

export const IconHeatmap: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <rect x="3" y="3" width="5" height="5" />
    <rect x="10" y="3" width="5" height="5" />
    <rect x="17" y="3" width="4" height="5" />
    <rect x="3" y="10" width="5" height="5" />
    <rect x="10" y="10" width="5" height="5" />
    <rect x="17" y="10" width="4" height="5" />
    <rect x="3" y="17" width="5" height="4" />
    <rect x="10" y="17" width="5" height="4" />
    <rect x="17" y="17" width="4" height="4" />
  </svg>
);

export const IconList: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <line x1="8" y1="6" x2="21" y2="6" />
    <line x1="8" y1="12" x2="21" y2="12" />
    <line x1="8" y1="18" x2="21" y2="18" />
    <line x1="3" y1="6" x2="3.01" y2="6" />
    <line x1="3" y1="12" x2="3.01" y2="12" />
    <line x1="3" y1="18" x2="3.01" y2="18" />
  </svg>
);

export const IconWind: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <path d="M9.59 4.59A2 2 0 1 1 11 8H2" />
    <path d="M17.73 2.73A2.5 2.5 0 1 1 19.5 7H2" />
    <path d="M12.83 20.83A2.5 2.5 0 1 0 14.5 17H2" />
  </svg>
);

export const IconFlame: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />
  </svg>
);

export const IconTrophy: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <line x1="6" y1="9" x2="18" y2="9" />
    <path d="M6 9V2h12v7" />
    <path d="M6 9c0 6 3 9 6 9s6-3 6-9" />
    <path d="M4 22h16" />
    <path d="M10 18v4" />
    <path d="M14 18v4" />
  </svg>
);

export const IconBrain: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2z" />
    <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2z" />
  </svg>
);

export const IconServer: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <rect x="2" y="2" width="20" height="8" rx="2" />
    <rect x="2" y="14" width="20" height="8" rx="2" />
    <line x1="6" y1="6" x2="6.01" y2="6" />
    <line x1="6" y1="18" x2="6.01" y2="18" />
  </svg>
);

export const IconTrend: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <polyline points="3 17 9 11 13 15 21 7" />
    <polyline points="14 7 21 7 21 14" />
  </svg>
);

export const IconRadar: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <circle cx="12" cy="12" r="3" />
    <circle cx="12" cy="12" r="7" />
    <circle cx="12" cy="12" r="11" />
    <line x1="12" y1="1" x2="12" y2="23" />
    <line x1="1" y1="12" x2="23" y2="12" />
  </svg>
);

export const IconAltitudeLine: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <polyline points="2 20 7 12 11 17 15 8 22 14" />
    <line x1="2" y1="22" x2="22" y2="22" />
  </svg>
);

export const IconMissionProgress: ComponentType<IconProps> = ({ className }) => (
  <svg {...base} className={className} width="16" height="16">
    <circle cx="12" cy="12" r="9" />
    <polyline points="8 12 11 15 16 9" />
  </svg>
);
